var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWiredEarphones = function SvgWiredEarphones(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#wiredEarphones_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#wiredEarphones_svg__b)",
    d: "M8.49 13.774c-.719.802-1.87 1.558-2.982 2.288-1.758 1.153-3.615 2.613-3.342 3.756h-.858c-.097-.767.249-1.677.992-2.42.707-.707 1.742-1.387 2.743-2.044 1.068-.7 2.171-1.425 2.816-2.145 1.633-1.824-1.49-5.102-1.521-5.135a.424.424 0 0 1 .61-.588c.036.038.909.95 1.552 2.148 1.144 2.135.626 3.43-.01 4.14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#wiredEarphones_svg__c)",
    d: "M16.547 12.632c-.017.057-.428 1.42-1.702 3.07-.884 1.146-2.791 2.838-5.232 4.116H7.58c3.059-1.2 5.555-3.295 6.57-4.6 1.19-1.531 1.582-2.813 1.585-2.826a.424.424 0 0 1 .812.24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#wiredEarphones_svg__d)",
    d: "M7.102 7.231c.107.19.118.382.066.55-.127.413-.643.677-1.072.377-2.358-1.647-3.946-6.623.02-7.276.87.571 1.69 2.083.96 3.579q-.055.111-.122.224c-1.124.036-.334 1.694.148 2.546"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D3AC7D",
    d: "M7.168 7.78c-.287-.15-.684-.49-1.208-1.205-1.327-1.807.27-3.96.27-3.96h.447l.398 1.846q-.054.111-.12.224c-1.125.036-.335 1.694.147 2.546.107.19.118.382.066.55"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFCFA4",
    d: "M8.964 4.587c-.886.609-1.535.583-2.009.098-.33-.337-.576-.897-.76-1.62-.197-.774-.373-1.617-.08-2.183.14-.27.387-.476.79-.582 3.228-.851 3.756 3.121 2.059 4.287"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BD996E",
    d: "M9.231 3.136c.225-.065.273-.582.11-1.157-.165-.575-.48-.989-.705-.924s-.273.582-.109 1.156c.164.575.48.989.704.925"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFCFA4",
    d: "M15.182 8.517c-1.53.64-2.842-1.788-1.88-3.401 1.055-1.767 3.744-1.016 3.746-.08.238 2.604.48 2.684-1.866 3.48"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#wiredEarphones_svg__e)",
    d: "M16.947 12.56c-.308.604-1.43.604-1.299-.016.274-1.295.364-2.217.353-2.873-.212-.615-.529-.902-.819-1.155a2 2 0 0 1-.205-.2c-1.264-1.398-.08-3.577 2.071-3.281.542.074 1.035.324 1.319.748 1.18 1.761-1.049 6.049-1.42 6.777"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D3AC7D",
    d: "M16.001 9.671c-.212-.615-.528-.902-.819-1.155a2 2 0 0 1-.205-.2c.027-.223.264-.282.373-.269 0 0 .627.014.651 1.624"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "wiredEarphones_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(113.904 .06 6.314)scale(11.9889 10.0444)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D59A4F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "wiredEarphones_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(129.158 3.302 9.535)scale(8.76651 9.70769)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D59A4F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "wiredEarphones_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-2.25407 6.51303 -4.55245 -1.57554 5.817 1.751)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D59A4F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "wiredEarphones_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-2.6183 7.04 -5.202 -1.93471 16.918 5.947)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D59A4F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "wiredEarphones_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.182.182h19.636v19.636H.182z"
  })))));
};
export default SvgWiredEarphones;